import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { SoCaiService } from '../services/so-cai.service';
import { UtilsService } from '../services/utils.service';

@Component({
  selector: 'app-tim-kiem',
  templateUrl: './tim-kiem.component.html',
  styleUrls: ['./tim-kiem.component.css']
})
export class TimKiemComponent implements OnInit {
  phi = {
    phicongchung: 0,
    phikhac: 0
  };
  tuNgay = '';
  denNgay = '';
  searchValue = '';
  tuNgayNormalizeStr = '';
  denNgayNormalizeStr = '';
  pageSize = 10;
  totalRecords: number = 0;
  loading: boolean = true;
  optionSearch: SearchOp[] = [];
  optionSeachSelected: any;
  data: any[] = [];
  itemChoosed: any[] = [];
  pageNumber = 0;

  searchForm: FormGroup;

  constructor(private router: Router, private soCaiService: SoCaiService, private changeDec: ChangeDetectorRef,
    private utilsService: UtilsService, private messageService: MessageService) {
    this.optionSearch = [{ val: '2', name: 'Số công chứng' }, { val: '1', name: 'Thông tin tài sản' },
    { val: '0', name: 'Người yêu cầu' }];
    this.data = [];
    this.itemChoosed = [];
    this.totalRecords = 0;

    this.searchForm = new FormGroup({
      optionSeachSelected: new FormControl(),
      searchValue: new FormControl(''),
      tuNgay: new FormControl(''),
      denNgay: new FormControl('')
    });
    this.searchForm.controls.optionSeachSelected.setValue(this.optionSearch[1]);
  }

  ngOnInit(): void {
  }
  ngAfterViewChecked(): void {
    // this.changeDec.detectChanges();
  }
  getAllSoCai() {
    this.loading = true;
    // get tu ngay, den ngay
    let tuNgayDate = this.searchForm.controls['tuNgay'].value;
    if (tuNgayDate != null && tuNgayDate != "") {
      this.tuNgayNormalizeStr = tuNgayDate.getFullYear() + '-' + (tuNgayDate.getMonth() + 1) + '-' + tuNgayDate.getDate();
    } else {
      this.tuNgayNormalizeStr = "";
    }
    let denNgayDate = this.searchForm.controls['denNgay'].value;
    if (denNgayDate != null && denNgayDate != "") {
      this.denNgayNormalizeStr = denNgayDate.getFullYear() + '-' + (denNgayDate.getMonth() + 1) + '-' + denNgayDate.getDate();
    }
    else {
      this.denNgayNormalizeStr = "";
    }
    var selectedSearchValue = this.searchForm.controls.optionSeachSelected.value.val;
    switch (selectedSearchValue) {
      case '1': {
        // Count
        this.soCaiService.countSoCaiByTTTS(this.searchForm.controls.searchValue.value,
          this.tuNgayNormalizeStr, this.denNgayNormalizeStr).subscribe(
            (resp: any) => {
              if (resp != undefined) {
                this.totalRecords = resp;
                this.pageNumber = 0;
                this.soCaiService.findSoCaiByTTTS(this.searchForm.controls.searchValue.value,
                  this.pageSize, this.pageNumber,
                  this.tuNgayNormalizeStr, this.denNgayNormalizeStr).subscribe(
                    (respSC: any) => {
                      if (respSC != undefined) {
                        this.data = respSC;
                        this.calPhi(this.data);
                        this.loading = false;
                      }
                    }
                  );
              }
            }
          );
      } break;
      case '0': {
        // Count
        this.soCaiService.countSoCaiByNYC(this.searchForm.controls.searchValue.value,
          this.tuNgayNormalizeStr, this.denNgayNormalizeStr).subscribe(
            (resp: any) => {
              if (resp != undefined) {
                this.totalRecords = resp;
                this.pageNumber = 0;
                this.soCaiService.findSoCaiByNYC(this.searchForm.controls.searchValue.value, this.pageSize,
                  this.pageNumber, this.tuNgayNormalizeStr, this.denNgayNormalizeStr).subscribe(
                    (respSC: any) => {
                      if (respSC != undefined) {
                        this.data = respSC;
                        this.calPhi(this.data);
                        this.loading = false;
                      }
                    }
                  );
              }
            }
          );
      } break;
      case '2': {
        // Count
        if (this.searchForm.controls.searchValue.value == '') {
          this.searchForm.controls.searchValue.setValue(0);
        }
        this.soCaiService.countSoCaiBySoCongChung(this.searchForm.controls.searchValue.value,
          this.tuNgayNormalizeStr, this.denNgayNormalizeStr).subscribe(
            (resp: any) => {
              if (resp != undefined) {
                this.totalRecords = resp;
                this.pageNumber = 0;
                this.soCaiService.findSoCaiBySoCongChung(this.searchForm.controls.searchValue.value, this.pageSize,
                  this.pageNumber, this.tuNgayNormalizeStr, this.denNgayNormalizeStr).subscribe(
                    (respSC: any) => {
                      if (respSC != undefined) {
                        this.data = respSC;
                        this.calPhi(this.data);
                        this.loading = false;
                      }
                    }
                  );
              }
            }
          );
      } break;
      default: { } break;
    }
  }

  getSoCai(event: LazyLoadEvent) {
    this.loading = true;
    if (event.rows != null) {
      this.pageSize = event.rows;
    }
    else {
      this.pageSize = 10;
    }
    var selectedSearchValue = this.searchForm.controls.optionSeachSelected.value.val;
    // get tu ngay, den ngay
    let tuNgayDate = this.searchForm.controls['tuNgay'].value;
    if (tuNgayDate != null && tuNgayDate != "") {
      this.tuNgayNormalizeStr = tuNgayDate.getFullYear() + '-' + (tuNgayDate.getMonth() + 1) + '-' + tuNgayDate.getDate();
    } else {
      this.tuNgayNormalizeStr = "";
    }
    let denNgayDate = this.searchForm.controls['denNgay'].value;
    if (denNgayDate != null && denNgayDate != "") {
      this.denNgayNormalizeStr = denNgayDate.getFullYear() + '-' + (denNgayDate.getMonth() + 1) + '-' + denNgayDate.getDate();
    }
    else {
      this.denNgayNormalizeStr = "";
    }
    switch (selectedSearchValue) {
      case '0': {
        this.soCaiService.countSoCaiByNYC(this.searchForm.controls.searchValue.value,
          this.tuNgayNormalizeStr, this.denNgayNormalizeStr).subscribe(
            (resp: any) => {
              if (resp != undefined) {
                this.totalRecords = resp;
                // this.pageNumber = 0;
                let pageCurrent = 0;
                if (event.first != null && event.first != undefined) {
                  pageCurrent = event.first / this.pageSize;
                }
                else {
                  pageCurrent = 0;
                }
                this.soCaiService.findSoCaiByNYC(this.searchForm.controls.searchValue.value,
                  this.pageSize, pageCurrent, this.tuNgayNormalizeStr, this.denNgayNormalizeStr).subscribe(
                    (res: any) => {
                      this.data = res;
                      this.calPhi(this.data);
                      this.loading = false;
                    }
                  );
              }
            }
          );
      } break;
      case '1': {
        this.soCaiService.countSoCaiByTTTS(this.searchForm.controls.searchValue.value,
          this.tuNgayNormalizeStr, this.denNgayNormalizeStr).subscribe(
            (resp: any) => {
              if (resp != undefined) {
                this.totalRecords = resp;
                // this.pageNumber = 0;
                let pageCurrent = 0;
                if (event.first != null && event.first != undefined) {
                  pageCurrent = event.first / this.pageSize;
                }
                else {
                  pageCurrent = 0;
                }
                this.soCaiService.findSoCaiByTTTS(this.searchForm.controls.searchValue.value,
                  this.pageSize, pageCurrent, this.tuNgayNormalizeStr, this.denNgayNormalizeStr).subscribe(
                    (res: any) => {
                      this.data = res;
                      this.calPhi(this.data);
                      this.loading = false;
                    }
                  );
              }
            }
          );
      } break;
      case '2': {
        let searchFinalValue = this.searchForm.controls.searchValue.value;
        if (searchFinalValue == null || searchFinalValue == undefined || searchFinalValue == "") {
          searchFinalValue = "0";
        }
        this.soCaiService.countSoCaiBySoCongChung(searchFinalValue,
          this.tuNgayNormalizeStr, this.denNgayNormalizeStr).subscribe(
            (resp: any) => {
              if (resp != undefined) {
                this.totalRecords = resp;
                // this.pageNumber = 0;
                let pageCurrent = 0;
                if (event.first != null && event.first != undefined) {
                  pageCurrent = event.first / this.pageSize;
                }
                else {
                  pageCurrent = 0;
                }
                this.soCaiService.findSoCaiBySoCongChung(this.searchForm.controls.searchValue.value,
                  this.pageSize, pageCurrent, this.tuNgayNormalizeStr, this.denNgayNormalizeStr).subscribe(
                    (res: any) => {
                      this.data = res;
                      this.calPhi(this.data);
                      this.loading = false;
                    }
                  );
              }
            }
          );
      } break;
      default: { } break;
    }
  }

  calendarChangeTuNgay(event: any) {
    let tuNgayDate = new Date(event);
    this.tuNgayNormalizeStr = tuNgayDate.getFullYear() + '-' + (tuNgayDate.getMonth() + 1) + '-' + tuNgayDate.getDate();
  }
  calendarChangeDenNgay(event: any) {
    let denNgayDate = new Date(event);
    this.denNgayNormalizeStr = denNgayDate.getFullYear() + '-' + (denNgayDate.getMonth() + 1) + '-' + denNgayDate.getDate();

  }

  exportExcel() {
    var selectedSearchValue = this.searchForm.controls.optionSeachSelected.value.val;
    switch (selectedSearchValue) {
      case '0': {
        this.utilsService.exportByNYC(this.searchForm.controls.searchValue.value, this.tuNgayNormalizeStr, this.denNgayNormalizeStr).subscribe(
          (resp: any) => {
            // window.location.href = resp.url;
            let blob = new Blob([resp], { type: resp.type });
            let url = window.URL.createObjectURL(blob);
            let pwa = window.open(url);
          },
          (error: any) => {
            this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi tải file!' });
          }
        );
      } break;
      case '1': {
        this.utilsService.exportByTTTS(this.searchForm.controls.searchValue.value, this.tuNgayNormalizeStr, this.denNgayNormalizeStr).subscribe(
          (resp: any) => {
            // window.location.href = resp.url;
            let blob = new Blob([resp], { type: resp.type });
            let url = window.URL.createObjectURL(blob);
            let pwa = window.open(url);
          },
          (error: any) => {
            this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi tải file!' });
          }
        );
      } break;
      case '2': {
        this.utilsService.exportBySoCongChung(this.searchForm.controls.searchValue.value, this.tuNgayNormalizeStr, this.denNgayNormalizeStr).subscribe(
          (resp: any) => {
            // window.location.href = resp.url;
            let blob = new Blob([resp], { type: resp.type });
            let url = window.URL.createObjectURL(blob);
            let pwa = window.open(url);
          },
          (error: any) => {
            this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi tải file!' });
          }
        );
      } break;
      default: { } break;
    }
  }

  downloadFile(id: number) {
    this.utilsService.downloadFile(id).subscribe(
      (resp: any) => {
        // window.location.href = resp.url;
        let blob = new Blob([resp], { type: resp.type });
        let url = window.URL.createObjectURL(blob);
        let pwa = window.open(url);
      },
      (error: any) => {
        this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi tải file!' });
      }
    );
  }

  timKiemSoCai() {
    this.getAllSoCai();
  }

  delete(id: number) {
    var _al = confirm('Bạn muốn xóa bản ghi này?');
    if (_al == true) {
      this.soCaiService.delete(id).subscribe(
        (resp: any) => {
          this.getAllSoCai();
          this.messageService.add({ severity: 'success', summary: 'Thông báo', detail: 'Đã thực hiện thành công!' });
        },
        (error: any) => {
          this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi xóa hồ sơ! Có thể bạn không có quyền xóa hồ sơ!' });
        }
      );
    }
  }

  homeNav() {
    this.router.navigate(['/home']);
  }

  themSoCaiNav() {
    this.router.navigate(['/socai']);
  }

  suaSoCaiNav(id: number) {
    this.soCaiService.checkQuyenSuaSoCai(id).subscribe(
      (resp: any) => {
        if (resp != null && resp != undefined) {
          if (resp.flag == 0) {
            this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Bạn không có quyền sửa hồ sơ này!' });
          }
          else {
            this.router.navigate(['/socai/' + id]);
          }
        }
      }
    );

  }

  onRowSelect(event: any) {
    this.messageService.add({ severity: 'info', summary: 'Product Unselected', detail: event.data.dsNYC_BenA });
  }

  calPhi(data: any) {
    if (data != undefined) {
      this.phi.phicongchung = 0;
      this.phi.phikhac = 0;
      for (let i = 0; i < data.length; i++) {
        this.phi.phicongchung += +data[i].phicongchung;
        this.phi.phikhac += +data[i].chiphikhac;
      }
    }
  }
}

interface SearchOp {
  name: string,
  val: string
}